export const margin = 6

// Z-index ladder for the Next.js app, lowest to highest:
// belowHeader < header < aboveHeader < stickyImportantElement < menu < modal < modalAlert
//
// Each value is a literal that must equal the matching `--z-index-*` custom property
// in app/nextjs/app/global.css. Deriving one layer from another (`headerZIndex + 2`)
// desynchronizes the two files as soon as a base value moves, so keep these literal.
// app/nextjs/styles/z-index-parity.spec.ts fails if the two ladders drift apart.
export const belowHeaderZIndex = 999
export const headerZIndex = 1000
export const aboveHeaderZIndex = 1002
export const stickyImportantElementZIndex = 1003
export const menuZIndex = 2000
export const modalZIndex = 2147483646
export const modalAlertZIndex = 2147483647

export const fontFamily = {
    title: 'var(--font-nexa-black), sans-serif',
    body: 'var(--font-interface), Helvetica Neue, helvetica, sans-serif',
}

export const desktopContent = 776
export const desktopWidth = 1040

export const tosBannerLocalStorageId = 'has-seen-privacy-banner-04-10-24'
